export default function AmesHeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Ames%20Iowa%20downtown%20and%20Iowa%20State%20University%20campus%20at%20golden%20hour%2C%20historic%20brick%20buildings%20and%20modern%20architecture%2C%20campus%20green%20spaces%20and%20tree-lined%20streets%2C%20professional%20drone%20photography%20with%20warm%20sunset%20colors%20and%20dramatic%20sky%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=ames-hero&orientation=landscape"
        alt="Ames Iowa downtown and Iowa State University campus at sunset"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40"></div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16 text-center">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          Emergency &amp; Expedited Passport Services in Ames, IA
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-3xl mx-auto mb-8 leading-relaxed">
          Iowa State University student preparing for a study-abroad program in Europe or Asia? Faculty researcher with a last-minute conference in Berlin or Tokyo? We help Ames residents — from ISU students and professors to Story County professionals to central Iowa families — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30&ndash;100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.
        </p>
        <a
          href="https://fastpassportcenter.com/checkout/"
          className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
        >
          Start My Passport <i className="ri-arrow-right-line"></i>
        </a>

        <div className="mt-10 w-full">
          <div className="inline-flex flex-wrap items-center justify-center gap-x-8 gap-y-3 bg-[#1A2B4A]/80 backdrop-blur-sm border border-white/10 rounded-lg px-8 py-3 mx-auto">
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-0.5">
                <i className="ri-star-fill text-[#F6C344] text-base"></i>
                <i className="ri-star-fill text-[#F6C344] text-base"></i>
                <i className="ri-star-fill text-[#F6C344] text-base"></i>
                <i className="ri-star-fill text-[#F6C344] text-base"></i>
                <i className="ri-star-fill text-[#F6C344] text-base"></i>
              </div>
              <span className="text-white font-bold text-sm">5.0</span>
              <span className="text-white/70 text-sm">Reviews</span>
            </div>
            <div className="hidden sm:block w-px h-5 bg-white/20"></div>
            <div className="flex items-center gap-2">
              <span className="text-white font-bold text-sm">BBB A+</span>
              <span className="text-white/70 text-sm">Accredited</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}